module.exports = __webpack_public_path__ + "img/ologo orig.894eac22.png";